import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsService } from 'src/app/services/forms.service';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { CommonService } from 'src/app/services/common.service';
import {
  ResponseMessageStatus,
  ResponseStatus,
  StockLocation,
} from '../../enums';
import { BadeLoftService } from 'src/app/views/badeloft-pages/bade-loft.service';
import { NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { Subscription } from 'rxjs';
registerLocaleData(en);
@Component({
  selector: 'app-add-update-stock',
  templateUrl: './add-update-stock.component.html',
  styleUrls: ['./add-update-stock.component.css'],
})
export class AddUpdateStockComponent implements OnInit {
  //#region properties
  isVisible = true;
  date = null;
  isEnglish = false;
  stockLocation: typeof StockLocation;
  lst_StockLocation: any = [];
  lst_PartNumber: any = [];
  @Output() hideModal = new EventEmitter();
  @Input() editStockDetail: any;
  // @Input() isImportClicked: boolean;
  @Input() isImportClicked: boolean = true;
  isAddPartPopOver: boolean = false;
  isEditPartPopOver: boolean = false;
  isStockNameValid: boolean = true;
  timer: any = null;
  lst_Parts: any = [];
  uploadedFile: any;
  formData: FormData = new FormData();
  isPartNumberExist: boolean = false;
  @Output() lst_Stocks: any;
  isPartsLoading: boolean = false;
  isQuantityExists = false;
  //#endregion

  //#region  functions
  showModal(): void {
    this.isVisible = true;
  }

  handleOk(): void {
    this._cS.markFormGroupTouched(this._fS.addUpdateStockForm);
    if (this._fS.addUpdateStockForm.valid) {
      var formValue = this._fS.addUpdateStockForm.value;
      if (!this.isImportClicked) {
        if (this.lst_PartNumber.length > 0 || this.isImportClicked) {
          var body: any;
          body = {
            name: formValue.name,
            etaDate: formValue.etaDate,
            status: +formValue.status,
            partNumbers: this.lst_PartNumber,
            containerNumber: formValue.containerNumber
              ? formValue.containerNumber
              : '',
          };
          if (!this.editStockDetail) {
            this._blS.CreateStock(body).subscribe((res) => {
              if (res) {
                if (
                  res.responseStatus == ResponseStatus.Success &&
                  res.result
                ) {
                  this._cS.displayMessage(
                    ResponseMessageStatus.success,
                    res.message
                  );

                  this.handleCancel(res.result);
                } else {
                  this._cS.displayMessage(
                    ResponseMessageStatus.success,
                    res.message
                  );
                }
              }
            });
          } else {
            body['id'] = this.editStockDetail.id;
            this._blS.UpdateStock(body).subscribe((res) => {
              if (res) {
                if (
                  res.responseStatus == ResponseStatus.Success &&
                  res.result
                ) {
                  this._cS.displayMessage(
                    ResponseMessageStatus.success,
                    res.message
                  );
                  this.handleCancel(res.result);
                } else {
                  this._cS.displayMessage(
                    ResponseMessageStatus.success,
                    res.message
                  );
                }
              }
            });
          }
        } else {
          this._cS.displayMessage(
            ResponseMessageStatus.info,
            'At least one part number should be needed in stock.'
          );
        }
      } else {
        this.importStock(formValue);
      }
    }
  }

  importStock(formValue: any) {
    if (formValue && this.uploadedFile) {
      let etaDate = this._cS.formatDate(formValue.etaDate);
      this.formData.append('Name', formValue.name);
      this.formData.append('ETADate', etaDate);
      this.formData.append(this.uploadedFile.name, this.uploadedFile);
      this.formData.append(
        'ContainerNumber',
        formValue.containerNumber ? formValue.containerNumber : ''
      );
      this._blS.ImportStock(this.formData).subscribe((res) => {
        if (res) {
          if (res.responseStatus == ResponseStatus.Success && res.result) {
            this._cS.displayMessage(ResponseMessageStatus.success, res.message);
            this.handleCancel(res.result);
          } else {
            this._cS.displayMessage(ResponseMessageStatus.error, res.message);
          }
        }
      });
    } else {
      this._cS.displayMessage(
        ResponseMessageStatus.error,
        'Please upload CSV file'
      );
    }
    this.formData = new FormData();
  }
  handleCancel(data?: any): void {
    this.isVisible = false;
    this.hideModal.emit({ hide: true, data: data ? data : null });
  }

  onDateChange(event: any) {}

  hideShowAddPart(event: any) {
    this._fS.addPartNumberForm.reset();
    this.isAddPartPopOver = event;
    if (
      this.isAddPartPopOver &&
      this.lst_Parts.length == 0 &&
      this.lst_Parts.length == 0
    )
      this.getPartNumbers();
    this._fS.addPartNumberForm.reset();
  }
  currentPartId: any;
  currentPartData: any = null;
  hideShowEditPart(event: any, partData: any) {
    this._fS.addPartNumberForm.reset();
    //remove validations of username and password while edit user
    const partNumberControl = this._fS.addPartNumberForm.get('partNumber');
    this._fS.addPartNumberForm
      .get('partNumber')
      ?.valueChanges.subscribe((userCategory) => {
        if (this.isEditPartPopOver) {
          partNumberControl?.setValidators(null);
        }
      });
    this.currentPartData = partData;
    this.isEditPartPopOver = event;
    if (this.isEditPartPopOver) {
      this.currentPartId = partData.id;
      this._fS.addPartNumberForm.patchValue({
        partNumber: partData.partNumber,
        orderQuantiry: partData.orderedQuantity,
        notes: partData.note,
      });
    }
  }
  checkQuantity() {
    if (this.isEditPartPopOver) {
      var formValue = this._fS.addPartNumberForm.value;
      if (formValue.partNumber) {
        var find = this.lst_Parts.find(
          (x: any) => x.value == formValue.partNumber
        );
        var index = this.lst_PartNumber.findIndex(
          (obj: any) => obj.partNumber == formValue.partNumber
        );
        // this.lst_PartNumber[index].orderedQuantity = formValue.orderQuantiry;
        if (
          formValue.orderQuantiry <
          this.lst_PartNumber[index].totalAssignedQuantity
        ) {
          //formValue.orderQuantiry = null;
          //this.isQuantityExists = true;
          this._cS.displayMessage(
            ResponseMessageStatus.warning,
            'Entered part quantity is lesser than assigned part quantity in the stock'
          );
        } else this.isQuantityExists = false;
      }
    }
  }
  addPartNumber() {
    if (this.isEditPartPopOver) {
      const partNumberControl = this._fS.addPartNumberForm.get('partNumber');
      this._fS.addPartNumberForm
        .get('partNumber')
        ?.valueChanges.subscribe((userCategory) => {
          if (this.isEditPartPopOver) {
            partNumberControl?.setValidators(null);
          }
        });
    }
    this._cS.markFormGroupTouched(this._fS.addPartNumberForm);
    if (this._fS.addPartNumberForm.valid) {
      var formValue = this._fS.addPartNumberForm.value;
      if (!this.isEditPartPopOver) {
        var part = this.lst_Parts.find(
          (p: any) => p.value == formValue.partNumber
        );
        var partIndex = this.lst_PartNumber.findIndex(
          (x: any) => x.partNumber == part.text
        );
        if (partIndex > -1) {
          this.isPartNumberExist = true;
          this._cS.displayMessage(
            ResponseMessageStatus.info,
            `Part number ${part.text} is already added.`
          );
        } else {
          this.isPartNumberExist = false;

          this.lst_PartNumber.push({
            id: part.value,
            partNumber: part.text,
            orderedQuantity: formValue.orderQuantiry,
            note: formValue.notes ? formValue.notes.trim() : '',
          });
          this.lst_PartNumber = [...this.lst_PartNumber];
        }
        this.hideShowAddPart(false);
      } else {
        var index = this.lst_PartNumber.findIndex(
          (obj: any) => obj.partNumber == formValue.partNumber
        );

        if (
          formValue.orderQuantiry <
          this.lst_PartNumber[index].totalAssignedQuantity
        ) {
          this._cS.displayMessage(
            ResponseMessageStatus.warning,
            'Entered part quantity is lesser than assigned part quantity in the stock'
          );
        } else {
          var partBody = {
            id: this.editStockDetail.id,
            partNumber: this.currentPartData.partNumber,
            orderedQuantity: formValue.orderQuantiry,
            note: formValue.notes,
          };
          this._blS.UpdatePartNumber(partBody).subscribe(
            (response: any) => {
              if (response.responseStatus == ResponseStatus.Success) {
                this._cS.displayMessage('success', response.message);
                this.lst_PartNumber[index].orderedQuantity =
                  formValue.orderQuantiry;
                this.lst_PartNumber[index].note = formValue.notes
                  ? formValue.notes.trim()
                  : '';

                this.hideShowEditPart(false, null);
              } else {
                this._cS.displayMessage('error', response.message);

                this.hideShowEditPart(true, null);
              }
            },
            (error) => {
              this._cS.displayMessage('error', error.message);

              this.hideShowEditPart(true, null);
            }
          );
          this.hideShowAddPart(false);
        }
      }
    }
  }

  removePartNumber(p: any, pi: number) {
    // var partNumber = this.editStockDetail != null ? this.editStockDetail?.partNumbers : this.lst_PartNumber;
    var partNumber = this.lst_PartNumber;
    if (partNumber?.length > 1) {
      if (this.editStockDetail) {
        if (partNumber[pi].totalAssignedQuantity == 0) {
          this._blS
            .DeleteStockPart(this.editStockDetail.id, p.partNumber)
            .subscribe((res) => {
              if (res) {
                if (res.responseStatus == ResponseStatus.Success) {
                  this._cS.displayMessage(
                    ResponseMessageStatus.success,
                    res.message
                  );
                  if (this.editStockDetail == null) {
                  }

                  //     this.lst_Stock[i].partNumbers.splice(pi, 1);
                  // this.lst_Stock[i].partNumbers = [ ...this.lst_Stock[i].partNumbers],
                  this.lst_PartNumber.splice(pi, 1);
                  this.lst_PartNumber = [...this.lst_PartNumber];
                  //partNumber = partNumber;
                } else {
                  this._cS.displayMessage(
                    ResponseMessageStatus.error,
                    res.message
                  );
                }
              }
            });
        } else
          this._cS.displayMessage(
            ResponseMessageStatus.info,
            'You can not remove the part because this part is assigned to someone.'
          );
      } else {
        this.lst_PartNumber.splice(pi, 1);
        this.lst_PartNumber = [...this.lst_PartNumber];
      }
    } else {
      this._cS.displayMessage(
        ResponseMessageStatus.info,
        'At least one part number should be needed in stock.'
      );
    }
  }

  validateStockName() {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.stockNameValidate(), 1000);
  }

  stockNameValidate() {
    var stockName = this._fS.addUpdateStockForm.value.name.trim();
    if (this.editStockDetail && this.editStockDetail.name == stockName) {
      this.isStockNameValid = true;
      return;
    } else if (stockName) {
      this._blS.ValidateStockName(stockName).subscribe((res) => {
        if (res) {
          if (res.responseStatus == ResponseStatus.NotFound) {
            this._cS.displayMessage(ResponseMessageStatus.warning, res.message);
            this.isStockNameValid = false;
          } else if (res.responseStatus == ResponseStatus.Success) {
            this.isStockNameValid = true;
          }
        }
      });
    }
  }

  cancelPartNumber() {
    this.isAddPartPopOver = false;
  }

  cancel() {}

  getPartNumbers() {
    try {
      this._blS.GetPartNumbers().subscribe((res) => {
        if (res) {
          if (res.responseStatus == ResponseStatus.Success && res.result) {
            this.lst_Parts = res.result;
          } else {
            this._cS.displayMessage(ResponseMessageStatus.error, res.message);
          }
        }
      });
    } catch (error) {}
  }

  onSelectPartNumber(event: any) {
    var part = this.lst_Parts.find((p: any) => p.value == event);
    if (part) {
      var partIndex = this.lst_PartNumber.findIndex(
        (x: any) => x.partNumber == part.text
      );
      if (partIndex > -1) {
        this.isPartNumberExist = true;
      } else {
        this.isPartNumberExist = false;
      }
    }
  }
  // The CSV is sent to the API on Save, so nz-upload must not post it anywhere
  // itself. Overriding nzCustomRequest keeps the file-list tile and the (nzChange)
  // capture working while making no network call at all. onSuccess is deferred
  // because nz-upload only adds the file to nzFileList in its own onStart(),
  // which runs after this returns.
  customRequest = (item: NzUploadXHRArgs): Subscription => {
    const timer = setTimeout(() => item.onSuccess!(null, item.file!, null));
    return new Subscription(() => clearTimeout(timer));
  };

  handleChange(event: any) {
    if (event.fileList.length > 0) {
      var fileNameSplit = event.file.name.split('.');
      if (fileNameSplit[fileNameSplit.length - 1] == 'csv') {
        this.uploadedFile = event.file.originFileObj;
        if (event.fileList.length > 1) {
          event.fileList.splice(event.fileList.length - 2, 1);
        }
      } else {
        event.fileList.splice(event.fileList.length - 1, 1);
        this._cS.displayMessage(
          ResponseMessageStatus.warning,
          'Only CSV file type is allowed'
        );
      }
    }
    // else {
    //   event.fileList.splice(event.fileList.length - 1, 1);
    //   if(event.type != 'removed') this._cS.displayMessage(ResponseMessageStatus.warning,'You can upload one file at a time');
    // }
  }
  uploadedCSVInfo(event: any) {
    try {
      var data = event.target.files[0];
      var fileNameSplit = data.name.split('.');
      if (fileNameSplit[fileNameSplit.length - 1] != 'csv') {
        this._cS.displayMessage(
          ResponseMessageStatus.error,
          'Only CSV file type is allowed'
        );
      } else {
        this.uploadedFile = event.target.files[0];
      }
    } catch (error) {}
  }

  handleUpload(event: any) {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      var fileNameSplit: any;
      fileNameSplit = reader.result?.toString().split(',');
      this.uploadedFile = fileNameSplit[1];
    };
  }

  downloadFile() {
    let link = document.createElement('a');
    link.download = 'samplestockimport.csv';
    link.href = 'assets/Stocks_Import.csv';
    link.click();
  }
  isAscPart: boolean = true;
  sortPart(isAsc: any) {
    this.isAscPart = isAsc;
    var ar = this.lst_PartNumber.sort(function (a: any, b: any) {
      var nA = isAsc ? a.partNumber.toLowerCase() : b.partNumber.toLowerCase();
      var nB = isAsc ? b.partNumber.toLowerCase() : a.partNumber.toLowerCase();

      if (nA < nB) return -1;
      else if (nA > nB) return 1;
      return 0;
    });
    this.lst_PartNumber = ar;
  }
  //#endregion
  constructor(
    public _fS: FormsService,
    public _cS: CommonService,
    private _blS: BadeLoftService
  ) {
    _fS.addUpdateStockForm_fb();
    _fS.addPartNumberForm_fb();
  }

  loadCurrentStockPartsData() {
    this.isPartsLoading = true;
    if (this.editStockDetail) {
      this._blS
        .GetPartNumberDetail(this.editStockDetail.id)
        .subscribe((res) => {
          if (res) {
            if (res.responseStatus == ResponseStatus.Success) {
              this.lst_PartNumber =
                res.result && res.result.length > 0 ? res.result : [];
            }
            this.isPartsLoading = false;
          }
        });
    }
  }
  ngOnInit(): void {
    this.loadCurrentStockPartsData();
  }

  ngAfterViewInit(): void {
    //this._cS.displayLoader(true)
    setTimeout(() => {
      this.showModal();
      this._fS.addUpdateStockForm.patchValue({
        name: this.editStockDetail ? this.editStockDetail.name : null,
        containerNumber: this.editStockDetail
          ? this.editStockDetail.containerNumber
          : null,
        etaDate: this.editStockDetail ? this.editStockDetail.etaDate : null,
        status: this.editStockDetail
          ? this.editStockDetail.status
          : StockLocation.OnProduction,
      });
      if (this.editStockDetail) {
        // this.lst_PartNumber =
        //   this.editStockDetail && this.editStockDetail.partNumbers?.length > 0
        //     ? this.editStockDetail.partNumbers
        //     : [];
      }
      this.lst_StockLocation = this._cS.lst_StockLocation;
    }, 100);
  }
}
